module.exports = __webpack_public_path__ + "img/user-guide-02-01.6bd1ed66.png";